// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"gN-z","smallCardRow":"hN-z","largeCardRow":"iN-z","productSearchRow":"jN-z","curatedRow":"kN-z"};